import React from 'react';
import { assigneeKindLabel } from './assigneeKind';

const AssigneeKindChip = ({ kind, name }) => {
  const label = assigneeKindLabel(kind);
  return (
    <div className="flex items-center gap-2">
      <span>{name || '---'}</span>
      {label ? (
        <span className="px-2 py-0.5 rounded text-xs bg-teal-50 text-teal-800">
          {label}
        </span>
      ) : null}
    </div>
  );
};

export default AssigneeKindChip;
